import Form from "../form";
export const items = [
    {title: "Tech", type: "Select", required: true, options: []},
    {title: "Date", type: "date", required: true}, 
    {title: "OQ Exp. Date", type: "date", required: true}, 
    {title: "Ticket Number", type: "text", required: true}, 
    {title: "Last Calibration Date", type: "date", required: true}, 
    {title: "Last ticket update", type: "date", required: true}, 
    {title: "auditFormBlock1", type: "display", content: <div className = "h2 mt-3 font-weight-bold">Ticket Photos</div>}, 
    // insert photos
    {title: "Is the beginning and end of delineated work area in the photographs?", type: "audit"}, 
    {title: "Were pictures taken of all marks placed?", type: "audit"}, 
    {title: "Were distance photos to include scope of excavation captured?", type: "audit"}, 
    {title: "auditFormBlock2", type: "display", content: <div className = "h2 mt-3 font-weight-bold">PT&T TICKETS</div>}, 
    {title: "Does recorded information on ticket appear to be consistent with known pole GPS location?", type: "audit"}, 
    {title: "Pole Number", type: "text"}, 
    {title: "Pole Information", type: "text"}, 
    {title: "Are the appropriate maps attached to the ticket?", type: "audit"}, 
    {title: "“No Conflict-Screened” ticket: Are there NO PG&E facilities within 250ft of the pole?", type: "audit"}, 
    {title: "auditFormBlock3", type: "display", content: <div className = "h2 mt-3 font-weight-bold">Audit Photos</div>}, 
    // insert photos
    {title: "Were reference points such as street signs, addresses, buildings used?", type: "audit"}, 
    {title: "Was the beginning and end of the work area in the pictures?", type: "audit"}, 
    {title: "Were distance photos taken that show scope of excavation?", type: "audit"}, 
    {title: "Is documentation accurate and understandable?", type: "audit"}, 


    {title: "Additional Tasks", type: "object", default: "[]", schema: [
        {title: "Contents", required: true, type: "textarea"},
        {title: "Quality", type: "select", required: true, options: [
            {label: "High", value: "High"},
            {label: "Medium", value: "Medium"},
            {label: "Low", value: "Low"},
            {label: "Fail", value: "Fail"}
        ]},
        {title: "Comments", type: "textarea"},
    ]},
];
//--------------------------------------------------------------------------------------------
export default function AuditForm({
    closeIt, 
    form, 
    picData, setPicData, 
    sketches, setSketches, 
    usersList, setUserList, 

    forms
}){
    items[0].options = usersList;
    //--------------------------------------------------------------------------------------------
    return(
        <Form
            closeIt = {closeIt}
            form = {form}
            picData = {picData}
            setPicData = {setPicData}
            sketches = {sketches}
            setSketches = {setSketches}
            usersList = {usersList}
            setUserList = {setUserList}
            
            items = {items}
            
            picsLimit = {1}

            forms = {forms}
        />
    )    
}